export default __webpack_public_path__ + "static/media/icon.b9231c1c.png";